module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0107.jpg?v=0a9b9ec2";